import wx from 'jweixin-module';
import wxApi from '@/api/wxApi';
import setter from '@/lib/setter';

export default {
    checkJsApi(apiList) {
        return new Promise((resolve, reject) => {
            wxApi.createJsapiSignature().then(res => {
                const data = res.data;
                wx.config({
                    debug: false,
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: apiList
                });

                wx.ready(() => {
                    wx.checkJsApi({
                        jsApiList: apiList,
                        success: res => {
                            if ('checkJsApi:ok' === res.errMsg) {
                                resolve(res);
                            } else {
                                reject();
                            }
                        }
                    });
                });
                wx.error(res => {
                    reject(res);
                });
            }).catch(() => {

            });
        });
    },
    checkJsApiLocation() {
        return new Promise((resolve, reject) => {
            wxApi.createJsapiSignature().then(res => {
                wx.getLocation({
                    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function(res) {
                        let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                        let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                        let tocoord = latitude + ',' + longitude;
                        // 这个是获取当前页面的路径
                        let url = location.href.split('#')[0];
                        let key = setter.txMapKey;
                        //let key = 'OJYBZ-DVF66-H6TSY-MWMPM-Q44RJ-ILFVU';
                        // 前往的路径
                        // backurl在选择完地点之后返回的路径
                        // 选择的地点参数都在地址栏里面，我这边是直接走后台获取
                        // 注意不可以携带json形式的map形式的参数
                        let goUrl =
                            'https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=' +
                            url +
                            '&key=' +
                            key +
                            '&policy=1&referer=official&coordtype=5&tocoord=' +
                            tocoord +
                            '';
                        window.location.href = goUrl;
                    },
                    fail() {
                        reject('获取位置信息失败，请打开定位');
                    },
                    cancel() {
                        reject('用户拒绝授权获取地理位置');
                    },
                    error() {
                        reject('获取失败');
                    }
                })
            }).catch(() => {
                reject('获取失败');
            });
        });
    },
    chooseWXPay(prepayId) {
        return new Promise((resolve, reject) => {
            wxApi.createPaySignature(prepayId).then(res => {
                const data = res.data;
                wx.chooseWXPay({
                    timestamp: data.timeStamp,
                    nonceStr: data.nonceStr,
                    package: data.packageValue,
                    signType: data.signType,
                    paySign: data.paySign,
                    complete(result) {
                        if ('chooseWXPay:ok' === result.errMsg) {
                            resolve();
                        } else if ('chooseWXPay:cancel' === result.errMsg) {
                            reject('取消支付');
                        } else {
                            reject(result.errMsg);
                        }
                    },
                    fail() {
                        reject('支付失败');
                    }
                });
            }).catch(() => {
                reject('支付失败');
            });
        });
    }

}
